var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrapper",class:_vm.propsClass},[_c('button',{staticClass:"button"},[_vm._v("test1")])])}
var staticRenderFns = []

export { render, staticRenderFns }